export default "__VITE_ASSET__BSwzkj9Y__"